import { useRef, useState } from "react";
import { ReplacementFile } from "features/reducers/replacementOrder/cart.ts";

export type FormMode = "base" | "special" | "other" | "revise";

export const useAddQuoteState = () => {
	const [isRevision, setIsRevision] = useState(false);
	const [lineItemMode, setLineItemMode] = useState<FormMode>("base");
	const [total, setTotal] = useState<number | undefined>(undefined);
	const [invalidUploads, setInvalidUploads] = useState<boolean>(false);
	const [uploadedFiles, setUploadedFiles] = useState<ReplacementFile[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const isRevisedValueSet = useRef<boolean>(false);

	return {
		isRevision,
		setIsRevision,
		lineItemMode,
		setLineItemMode,
		total,
		setTotal,
		invalidUploads,
		setInvalidUploads,
		uploadedFiles,
		setUploadedFiles,
		isLoading,
		setIsLoading,
		isRevisedValueSet
	};
};
